import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import { SeasonBanner } from './Components/SeasonBanner';
import styled from 'styled-components';
import { UpcomingShows } from './Components/UpcomingShows';
import { StatisticsSection } from './Components/StatisticsSection';
import MetricsDashboard from './Components/PaymentSection';
import Cookies from 'js-cookie';

type Props = {};

const DashboardPage = (props: Props) => {
  const userType = Cookies.get('userType');
  const breadCrumbItems = [
    {
      id: '',
      text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
      disabled: true,
    },
    {
      id: userType === 'COACH' ? '/coach/dashboard/' : '/admin/dashboard',
      text: 'Dashboard',
    },
  ];
  return (
    <CommonPageWrapper>
      <HeadingWrapper>
        <PageMainLabel>Dashboard</PageMainLabel>
        <CustomBreadCrumb preData={breadCrumbItems} />
      </HeadingWrapper>
      <MainContent>
        <SeasonBanner />
        <ContentLayout>
          <UpcomingShows />
          {(userType === 'ADMIN' || userType === 'DATAENTRYUSER') && (
            <MetricsDashboard />
          )}
          <StatisticsSection />
        </ContentLayout>
      </MainContent>
    </CommonPageWrapper>
  );
};
export default DashboardPage;
const MainContent = styled.section`
  margin-top: 19px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ContentLayout = styled.div`
  margin-top: 13px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
